import React from 'react';
import { useReveal, PageHero, SectionHead, Photo, GetInvolved } from '../Components/shared';
import { ORG, VISION, MISSION, ABOUT_LEAD, ABOUT_BODY, COMMITMENTS } from '../data/site';

function About() {
  const ref = useReveal();
  return (
    <main id="main" ref={ref}>
      <PageHero
        eyebrow="About EMANAC"
        title={['Empowering minds for', 'next-gen computing.']}
        lead={ABOUT_LEAD}
        photo="readingTogether"
      />

      <section className="section">
        <div className="wrap two-col">
          <div>
            <div data-reveal>
              <p className="kicker">Our story</p>
              <h2 className="h2">A hub for innovation and shared growth.</h2>
            </div>
            <Photo name="studentPortrait" className="two-col-photo" sizes="(max-width: 860px) 100vw, 45vw" />
          </div>
          <div className="prose">
            {ABOUT_BODY.map((p) => <p key={p.slice(0, 20)} className="body-lg" data-reveal>{p}</p>)}
            <p className="body-lg" data-reveal>
              We aim to equip individuals with the skills needed to excel in technology, entrepreneurship,
              and data-driven industries. Above all, we are committed to nurturing a culture of continuous
              learning and adaptability, ensuring our members remain at the forefront of technological advancements.
            </p>
          </div>
        </div>
      </section>

      <section className="section dark">
        <div className="wrap purpose">
          <Photo name="girlsLaptop" className="purpose-photo" sizes="(max-width: 860px) 100vw, 50vw" />
          <div className="purpose-copy">
            <div className="purpose-item" data-reveal>
              <p className="kicker on-dark">Our vision</p>
              <p className="purpose-text">{VISION}</p>
            </div>
            <div className="purpose-item" data-reveal style={{ '--d': 1 }}>
              <p className="kicker on-dark">Our mission</p>
              <p className="purpose-text">{MISSION}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="wrap">
          <SectionHead kicker="What we stand for" title="Our commitments." />
          <ol className="commits">
            {COMMITMENTS.map((c, i) => (
              <li key={c.title} data-reveal style={{ '--d': i }}>
                <span className="numbered-n">{String(i + 1).padStart(2, '0')}</span>
                <h3 className="h3">{c.title}</h3>
                <p className="body">{c.body}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="section section-mist">
        <div className="wrap name-block" data-reveal>
          <p className="kicker">The name</p>
          <p className="name-big">{ORG.name}</p>
          <p className="name-exp">{ORG.expansion}</p>
          <p className="name-motto">“{ORG.motto}”</p>
        </div>
      </section>

      <GetInvolved title="Be part of the story." photo="computerLab" />
    </main>
  );
}

export default About;
